var map = {
	"./action.svg": 96,
	"./address-location.svg": 16,
	"./arrow-to-left.svg": 97,
	"./arrow-to-top.svg": 98,
	"./arrows-back.svg": 17,
	"./back.svg": 99,
	"./checked.svg": 100,
	"./checked2.svg": 101,
	"./circle-cross.svg": 18,
	"./close.svg": 102,
	"./cross.svg": 103,
	"./down.svg": 104,
	"./github.svg": 105,
	"./hook-red.svg": 19,
	"./message.svg": 106,
	"./minus.svg": 20,
	"./more.svg": 107,
	"./more2.svg": 108,
	"./more3.svg": 109,
	"./notice.svg": 110,
	"./plus.svg": 21,
	"./qrcode.svg": 111,
	"./right.svg": 112,
	"./search.svg": 113,
	"./search2.svg": 114,
	"./share.svg": 115,
	"./tick-red.svg": 22,
	"./tick.svg": 116,
	"./top.svg": 117,
	"./trolley.svg": 118,
	"./unchecked.svg": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;